export type SubscriptionTier = 'free' | 'premium' | 'super'

function normalizeSubscriptionLevel(raw: unknown): SubscriptionTier | null {
  if (typeof raw !== 'string') return null
  const v = raw.trim().toLowerCase()
  if (v === 'free' || v === 'premium' || v === 'super') return v
  return null
}

/**
 * Derives web app subscription flags from Bazaart access-token JWT claims.
 * `subscription_level` is authoritative when recognized; `is_premium` is a transitional fallback.
 */
export function deriveSubscriptionFlagsFromAccessTokenPayload(
  payload: Record<string, unknown>
): { userIsPremium: boolean; userIsSuper: boolean } {
  const tier = normalizeSubscriptionLevel(payload.subscription_level)
  const legacyPremium = Boolean(payload.is_premium)

  if (tier === 'super') {
    return { userIsPremium: true, userIsSuper: true }
  }
  if (tier === 'premium') {
    return { userIsPremium: true, userIsSuper: false }
  }
  if (tier === 'free') {
    return { userIsPremium: false, userIsSuper: false }
  }

  return {
    userIsPremium: legacyPremium,
    userIsSuper: false,
  }
}
